import Template from '../template'
import requestPremiumSrc from './request-premium.txt'

const requestPremium = new Template(
  // Removing '\n' from the end
  requestPremiumSrc.slice(0, requestPremiumSrc.length - 1)
)

export default { requestPremium }
export { requestPremium }
